import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import styles from './Dots.pcss';
const Dots = ({ currentIndex, indexes })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.dots,
        children: indexes.map((index)=>/*#__PURE__*/ _jsx("div", {
                className: cn(styles.dots__dot, {
                    [styles['dots__dot--active']]: currentIndex === index
                })
            }, index))
    });
};
export default Dots;
